import {Form} from '../../../../stores/Form';

export const getHTMLCellID = (form: Form, row: number, columnIndex: number) => {
    return `${form.ename}_${form.session}_${row}_${columnIndex}`;
};
